var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4 38.4C29.051 38.4 31.2 40.549 31.2 43.2C31.2 45.851 29.051 48 26.4 48C23.749 48 21.6 45.851 21.6 43.2C21.6 40.549 23.749 38.4 26.4 38.4ZM11.379 31.2C14.6927 31.2 17.379 33.8863 17.379 37.2C17.379 40.5137 14.6927 43.2 11.379 43.2C8.06527 43.2 5.37898 40.5137 5.37898 37.2C5.37898 33.8863 8.06527 31.2 11.379 31.2ZM39.1664 32.4C41.8174 32.4 43.9664 34.549 43.9664 37.2C43.9664 39.851 41.8174 42 39.1664 42C36.5154 42 34.3664 39.851 34.3664 37.2C34.3664 34.549 36.5154 32.4 39.1664 32.4ZM44.4 22.3645C46.3882 22.3645 48 23.9763 48 25.9645C48 27.9527 46.3882 29.5645 44.4 29.5645C42.4118 29.5645 40.8 27.9527 40.8 25.9645C40.8 23.9763 42.4118 22.3645 44.4 22.3645ZM6 14.4C9.31371 14.4 12 17.0863 12 20.4C12 23.7137 9.31371 26.4 6 26.4C2.68629 26.4 0 23.7137 0 20.4C0 17.0863 2.68629 14.4 6 14.4ZM42.6859 12.4974C44.0114 12.4974 45.0859 13.5719 45.0859 14.8974C45.0859 16.2229 44.0114 17.2974 42.6859 17.2974C41.3604 17.2974 40.2859 16.2229 40.2859 14.8974C40.2859 13.5719 41.3604 12.4974 42.6859 12.4974ZM19.2 0C23.1765 0 26.4 3.22355 26.4 7.2C26.4 11.1765 23.1765 14.4 19.2 14.4C15.2236 14.4 12 11.1765 12 7.2C12 3.22355 15.2236 0 19.2 0ZM37.2 7.2C37.8627 7.2 38.4 7.73726 38.4 8.4C38.4 9.06274 37.8627 9.6 37.2 9.6C36.5373 9.6 36 9.06274 36 8.4C36 7.73726 36.5373 7.2 37.2 7.2Z",
    fill: "#0F314D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCampaign);
export default __webpack_public_path__ + "static/media/loadingCampaign.8594c2eae08355326a8a468ce1e6561e.svg";
export { ForwardRef as ReactComponent };